import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePagination } from "@hooks/usePagination";
import cn from "classnames";
import { useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
export const Pagination = (props) => {
    const { forcePage, totalCount, pageNumberCount = 5, pageSize, shouldReset = false, className, onPageChange } = props;
    const { isLastSet, currentPage: activePage, pageNumbers, offset, lastPage, nextPage, nextSet, prevPage, prevSet, goToPage, setOffset } = usePagination({
        totalCount,
        pageNumberCount,
        pageSize
    });
    const currentPage = forcePage || activePage;
    useEffect(() => {
        if (typeof shouldReset === "boolean" && shouldReset) {
            goToPage(1);
            setOffset(0);
        }
    }, [shouldReset]);
    useEffect(() => {
        if (forcePage) {
            goToPage(forcePage);
        }
    }, [forcePage]);
    useEffect(() => {
        !!onPageChange && onPageChange(activePage);
    }, [activePage]);
    return (_jsxs("div", { className: cn("pagination__container", className), children: [currentPage !== 1 && (_jsx("button", { className: "pagination__page-btn", onClick: prevPage, children: _jsx(FaChevronLeft, {}) })), _jsxs("div", { className: "pagination__items", children: [offset !== 0 && (_jsx("button", { className: "pagination__set-btn", onClick: prevSet, children: _jsx("span", { children: "..." }) })), pageNumbers.map((number, index) => (_jsx("button", { className: cn("pagination__page-number", { "pagination__page-number--active": currentPage === number }), onClick: () => goToPage(number), children: number }, `${number}-${index}`))), !isLastSet && (_jsx("button", { className: "pagination__set-btn", onClick: nextSet, children: _jsx("span", { children: "..." }) }))] }), currentPage !== lastPage && (_jsx("button", { className: "pagination__page-btn", onClick: nextPage, children: _jsx(FaChevronRight, {}) }))] }));
};
